
import ETC_AXIOS from './etc.axios'
import axios from 'axios'
import APP from '../config/app'

// 获取客服跳转参数
export const customService = (data = {}) => {
  return ETC_AXIOS.post(APP.HTTP_SW_URL + '/no-login/new-customer-order-info', data, {
    headers: {
      'x-app-source': 9
    }
  })
}

// 获取微信h5客服跳转参数
export const customServiceWechat = (data = {}) => {
  return ETC_AXIOS.post(APP.HTTP_SW_URL + '/no-login/new-customer-order-info', data, {
    headers: {
      'x-app-source': 11
    }
  })
}

export const fontFetch = (url) =>  {
  const t = (new Date().getTime() / 10000).toFixed(0)
  return axios.get(APP.HTTP_CF_URL + url + `?t=${t}`)
}
